<template>
  <v-menu
      v-model="show"
      bottom
      left
      nudge-bottom="50"
      nudge-left="20"
      close-on-click
      :close-on-content-click="false"
      min-width="450px"
  >
    <template #activator="{on, attrs}">
      <v-btn
          icon
          v-on="on"
          v-bind="attrs"
          @click=" show= !show"
      >
        <v-icon size="24" color="primary">
          mdi-eye
        </v-icon>
      </v-btn>
    </template>
    <v-card class="comments-menu-card">
      <v-btn class="close-click" icon @click="show = false">
        <v-icon size="24"  color="primary">mdi-close</v-icon>
      </v-btn>
        <v-card-title>
          <slot name="header-title">
            <h3>
              Комментарий
            </h3>
          </slot>
        </v-card-title>
        <v-card-text
            class="d-flex flex-column"
        >
          <p v-text="text"></p>
        </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>

export default {
  name: "comment-menu",
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: false,

    }
  },
}
</script>

<style scoped>

</style>